// extracted by mini-css-extract-plugin
module.exports = {"radius":"FigureBox_radius__3A-VR"};